import UserList from '@/data/user/view/list.vue'
import UserDetail from '@/data/user/view/detail.vue'

const list = {
  path: '/user',
  name: 'user-list',
  component: UserList
}

const listOfAdmin = {
  path: '/admin',
  name: 'admin-list',
  component: UserList
}

const detail = {
  path: '/user/:id(\\d+)',
  name: 'user-detail',
  component: UserDetail
}

export default [list, detail, listOfAdmin]
